import { createUuid } from '@app/utilities';
import BaseComponent from "../BaseComponent";
import Dropdown from "../Dropdown";
import Button from "../Button";
import OldInput from "../OldInput";
import { OldSwitch } from "../OldSwitch";
import { speakAsOptions } from "../../const";

export default class DynamicVariableSubCon extends BaseComponent {
    /**
     * Submenu view for dynamic variable reference
     * @module DynamicVariableSubCon
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.state = {
            defaultValue: props.data.input.defaultValue,
            sel: speakAsOptions.findIndex((item) => item.value === props.data.input.speakAs)
        }
        this.varModel = props.data.input || this.initVarModel();
        this.varModel.sensitive = (props.data && this.varModel.sensitive) ? this.varModel.sensitive : false;
        this.varIdx = props.data.varIdx;
    }

   /**
     * Set config proxy; catches own input value updates and update its data model before saving to list
     * @param {string} key
     * @param {string|boolean} value
     */
    setConfig(key, value) {
        this.varModel[key] = value;
        if(key === "speakAs") {
            const speakAsObject = speakAsOptions.find((item) => item.value === value);
            const idx = speakAsOptions.findIndex((item) => item.value === value);
            this.varModel.defaultValue = speakAsObject.defaultValue;
            this.setState({defaultValue : speakAsObject.defaultValue});
            this.setState({sel : idx});
        } else {
            this.setState({defaultValue : value});
        }    
    }

    /**
     * Initialize dummy data model
     * @returns {Object}
     */
    initVarModel() {
        return {
            argumentName: null,
            id: createUuid(),
            type: "variable",
            value: null,
            varName: null,
            speakAs: null,
            defaultValue: null,
            sensitiveData: false
        };
    }

    getConfig(key) {
        return this.varModel[key];
    }

    isKnownModel() {
        return this.props.data.input;
    }

    /**
     * getSensitiveData 
     * @param {input or localVariable} 
     * @returns boolean
     */
    getSensitiveData(input) {
        const scope = input.varName.split(".")[0];
        const isParentNode = this.props.context.props.context.hasWriteProxy();
        
        // app-scoped input
        if (scope === "app") {
            return input.sensitive;
        }

        // input is a localVariable
        if (scope === "mod"&& !isParentNode) {
            const currentModuleId = window.apm.getCurrentDiagramWidget().props.node.id;
            const varName = input.varName.split(".")[1];
            const variable = window.apm.getVariable(varName, currentModuleId);

            if (variable) {
                return variable.props.config.sensitiveData;
            }

            return false;
        }
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        const sel = this.state.sel;
        const sensitiveData = this.getSensitiveData(this.varModel); 
        return (
            <div>
                <div className={"form-component-container"}>
                    <label>{this.getPropLabel("variable")}</label><br />
                    <span>{this.varModel.argumentName}</span>
                </div>
                {<Dropdown 
                    wide={true} 
                    label={this.getPropLabel("speak_as")} 
                    optionName={this.getPropLabel("select_type")}
                    options={speakAsOptions}
                    context={this} 
                    valKey={"speakAs"}
                    selection={sel}
                    />}
                <OldInput 
                    label={this.getPropLabel("default_value")} 
                    hint={this.getPropLabel("default_value")}
                    context={this} 
                    valKey={"defaultValue"} 
                    value={this.state.defaultValue} 
                    key={this.state.defaultValue} 
                    valRules={{"defaultValue": true}}
                />
                {!this.props.context.props.context.hasWriteProxy()&&
                    <OldSwitch 
                        context={this} 
                        label={this.getPropLabel("sensitive")} 
                        valKey={"sensitive"}
                        value={this.varModel.sensitive} 
                        disabled={true} 
                        checked={sensitiveData} 
                        tooltip={'Sensitivity is derived from variable sensitive data'} 
                        key={"sensitive"} 
                    />}
                {this.props.context.props.context.hasWriteProxy() && this.varModel && this.varModel.varName.includes("app.") &&
                    <OldSwitch 
                        context={this} 
                        label={this.getPropLabel("sensitive")} 
                        valKey={"sensitive"}
                        value={this.varModel.sensitive} 
                        disabled={true} 
                        checked={sensitiveData} 
                        tooltip={'Sensitivity is derived from variable sensitive data'}
                        key={"sensitive"}
                    />}
                <table style={{ width: "100%" }}><tbody><tr>
                    <td>
                        {<Button label={this.getPropLabel("save")} wide={true}
                            callback={() => {
                                this.props.context.update(this.varModel, this.varIdx);
                                this.props.domContext.removeSubmenu();
                            }}
                        />}
                    </td>
                </tr></tbody></table>
            </div>
        );
    }
}